document.addEventListener("DOMContentLoaded", function () {
    let btnOrder = document.querySelectorAll('.js-order-tabs-btn button'),
        firstStep = document.querySelector('#firstStep'),
        secondStep = document.querySelector('#secondStep'),
        thirdStep = document.querySelector('#thirdStep'),
        firstPath = document.querySelector('.js-path-first'),
        secondPath = document.querySelector('.js-path-second'),
        thirdPath = document.querySelector('.js-path-third'),
        allPath = document.querySelectorAll('.js-path-all'),
        goFirstStep = document.querySelector('.js-go-first-step'),
        goSecondStep = document.querySelectorAll('.js-go-second-step'),
        goThirdStep = document.querySelector('.js-go-third-step'),
        allSteps = document.querySelectorAll('.js-order-steps');

    if (firstStep) {
        function disableBtnActive() {			
            btnOrder.forEach(item => {
                item.classList.remove('_active');
            });
        }

        btnOrder.forEach(item => {
            item.addEventListener('click', () => {
                disableBtnActive();
                item.classList.add('_active');
            });
        });

        function disableAllSteps() {
            allSteps.forEach(item => {
                item.classList.add('hidden');
            });
            allPath.forEach(item => {
                item.classList.remove('_active');
            });
            window.scrollTo(0, 0);
        }

        function changeToFirstStep() {
            disableAllSteps();
            firstStep.classList.remove('hidden');
            firstPath.classList.add('_active');
        }

        function changeToSecondStep() {
            disableAllSteps();
            secondStep.classList.remove('hidden');
            secondPath.classList.add('_active');

            let orderPage = document.querySelector('.js-total-disable');
            orderPage.classList.remove('_one-row');
            orderPage.querySelector('.order-aside').classList.remove('hidden');
        }

        function changeToThirdStep() {
            disableAllSteps();
            thirdStep.classList.remove('hidden');
            thirdPath.classList.add('_active');

            let orderPage = document.querySelector('.js-total-disable');
            orderPage.classList.add('_one-row');
            orderPage.querySelector('.order-aside').classList.add('hidden');
        }

        goFirstStep.addEventListener('click', () => {
            changeToFirstStep();
        });

        goSecondStep.forEach(item => {
			if(item.id != 'step1'){
				item.addEventListener('click', () => {
					changeToSecondStep();
				});
			}
        });

        goThirdStep.addEventListener('click', () => {
            //changeToThirdStep();
        });

		let birth_check = $('#birth_required').val();

		$(document).on('change','#birthday', function(){
			$.ajax({
			  url: '/ajaxhandler2',
			  type: 'POST',
			  data: {
				  birth: 'true',
				  v: this.value
			  },
			  success: function(resp) {
				  if(resp == 'y'){
					  $('#birth_text').hide();
					  birth_check = 1;
				  }
				  else{
					  $('#birth_text').show();
					  birth_check = 0;
				  }
			  }
			});
		});

		$(document).on('click','#step1', function(){
			let d = document.querySelectorAll('.p-order__delivery-item');
			let flag = 0;
			let errors = '';
			let message_obj = $('#main__error');

			d.forEach(item => {
				if(item.classList.contains("_active")){
					if(item.dataset.id == 11 || item.dataset.id == 14){
						if($('#point').val()){
							flag = 1;
						}
						else{
							flag = 2;
						}
					}
					else{
						flag = 1;
					}
				}
			});

			if(flag === 1){
				changeToSecondStep();
			}
			if(flag === 2){
				errors = 'Выбери пункт доставки.';
				message_obj.html(errors);
				message_obj[0].classList.add('_active');
				setTimeout(() => {
					message_obj[0].classList.remove('_active');
				}, 3000);
			}
			if(flag === 0){
				errors = 'Выбери способ доставки.';
				message_obj.html(errors);
				message_obj[0].classList.add('_active');
				setTimeout(() => {
					message_obj[0].classList.remove('_active');
				}, 3000);
			}
		});

		$(document).on('click','#step2', function(){
			let errors = '';
			let message_obj = $('#main__error');

			fls1 = $('#surname').val();
			fls2 = $('#name').val();
			fls3 = $('#phone').val();
			fls4 = $('#email').val();
			fls5 = $('#address').val();
			
			if(birth_check == '0' || birth_check == 0){
				fls6 = false;
			}
			else{
				fls6 = true;
			}

			$('#surname').parent()[0].classList.remove('input__error');
			$('#name').parent()[0].classList.remove('input__error');
			$('#phone').parent()[0].classList.remove('input__error');
			$('#email').parent()[0].classList.remove('input__error');
			$('#address').parent()[0].classList.remove('input__error');

				console.log(fls1);
				console.log(fls2);
				console.log(fls3);
				console.log(fls4);
				console.log(fls5);
				console.log(fls6);

			if(fls1 && fls2 && fls3 && fls4 && fls5 && fls6){				
				changeToThirdStep();
				dataLayer.push({
					'event': 'add_shipping_info',
					'ecommerce': {
						'shipping_tier': 'tier',
						'items': gt_order_items
					}
				});
			}
			else{
				if(!fls1){
					$('#surname').parent()[0].classList.add('input__error');
				}
				if(!fls2){
					$('#name').parent()[0].classList.add('input__error');
				}
				if(!fls3){
					$('#phone').parent()[0].classList.add('input__error');
				}
				if(!fls4){
					$('#email').parent()[0].classList.add('input__error');
				}
				if(!fls5){
					$('#address').parent()[0].classList.add('input__error');
				}
				if(!fls6){
					$('#birthday').parent()[0].classList.add('input__error');
				}

				errors = 'Заполни обязательные поля';
				message_obj.html(errors);
				message_obj[0].classList.add('_active');
				setTimeout(() => {
					message_obj[0].classList.remove('_active');
				}, 3000);
			}
		});
		
		$(document).on('click','#step3', function(e){
			let errors = '';
			let message_obj = $('#main__error');
			console.log($('#politics')[0].checked);
			if($('#politics')[0].checked){

			}
			else{
				e.preventDefault();				
				errors = 'Необходимо согласие с условиями публичной оферты и политики конфиденциальности.';
				message_obj.html(errors);
				message_obj[0].classList.add('_active');
				$('#politics_text').css('color','#000ca0');
				setTimeout(() => {
					message_obj[0].classList.remove('_active');
				}, 3000);
				return false;
			}
		});
    }
});